import { useState } from 'react';
import { Tab, TabProps } from 'react-admin';
import { FCRAWorker } from '@/types/turn-api';
import AddAddressForm from './AddAddressForm';
import EditAddressForm from './EditAddressForm';
import Table from './Table';
import { ActionButtonStyled, Container } from './styled';

const AddressesTab = (props: Partial<TabProps>) => {
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [editingAddress, setEditingAddress] = useState<FCRAWorker.Address | null>(null);

  const openAddForm = () => {
    setEditingAddress(null);
    setShowAddressForm(true);
  };

  const closeAddForm = () => setShowAddressForm(false);

  return (
    <Tab id="candidate-addresses-tab" label="addresses" {...props}>
      {showAddressForm ? (
        <AddAddressForm onClose={closeAddForm} />
      ) : editingAddress ? (
        <EditAddressForm address={editingAddress} onClose={() => setEditingAddress(null)} />
      ) : (
        <Container>
          <ActionButtonStyled iconType="addCircleOutline" label="Add Address" onClick={openAddForm} />
          <Table onEdit={setEditingAddress} />
        </Container>
      )}
    </Tab>
  );
};

export default AddressesTab;
